<template>
   <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper pb-1">
      <section id="card-navigation modern-horizontal-wizard">
        <div style="font-weight: bold; text-align: center">404 Page Not Found</div>
      </section>
    </div>   
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  components: {},
  data() {
    return {
      
    }
  },
  mounted() {},
  methods: {}
}
</script>
